import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const commonCheckoutFormStyles = (theme: Theme, checkoutButtonColor?: string) => ({
	checkBox: {
		color: '#FFFFFF',
		m: 0,
		gap: '12px',
		minWidth: '120px',

		'& .MuiStack-root': {
			flex: 1,
		},

		'& .MuiFormControlLabel-label, & a': {
			color: 'rgba(255, 255, 255, 0.7)',
			fontFamily: 'Montserrat',
			fontWeight: 500,
			lineHeight: '21px',
			userSelect: 'none',

			'&.Mui-disabled': {
				color: 'rgba(255, 255, 255, 0.4)',
			},
		},

		'& .MuiCheckbox-root': {
			height: '18px',
			width: '18px',
			minWidth: '18px',
			p: 0,
			borderRadius: '4px',
			boxShadow: '0 0 0 1px #FFFFFF4D',
			backgroundColor: '#FFFFFF33',
			flexShrink: 0,
			ml: '5px',

			'&:hover': {
				backgroundColor: '#FFFFFF33',
				boxShadow: '0 0 0 1px #FFFFFF',
			},

			'& .MuiSvgIcon-root, & .MuiTouchRipple-root': {
				display: 'none',
			},

			'&.Mui-checked': {
				color: '#FFFFFF',
				boxShadow: '0 0 0 1px #FFFFFF4D',

				'& .MuiSvgIcon-root': {
					width: '14px',
					height: '14px',
					display: 'block',
				},
			}
		},
	},
	loader: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	title: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '19px',
		color: '#FFFFFF',
		mt: '-3px',
	},
	secondaryButton: {
		p: '5px 12px 7px',
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '12px',
		fontWeight: 400,
		lineHeight: '14px',
		color: '#FFFFFF',
		borderRadius: '25px',
		backgroundColor: '#FFFFFF1A',

		'&:hover': {
			backgroundColor: '#FFFFFF4D',
		},

		'&:disabled': {
			color: '#FFFFFF',
			opacity: 0.2,
		},
	},
	submitButton: {
		height: '50px',
		minWidth: '132px',
		borderRadius: '100px',
		color: '#000000',
		fontWeight: 500,
		fontSize: '12px',
		lineHeight: '14px',
		fontFamily: 'Integral CF, sans-serif',
		textTransform: 'uppercase',
		p: '10px 32px',
		backgroundColor: checkoutButtonColor || '#FFFFFF',

		'&:hover': {
			backgroundColor: '#000000',
			color: '#FFFFFF',
		},

		'&:active': {
			backgroundColor: '#000000',
			color: '#FFFFFF',
		},
	},
})

export const checkoutFormStyles = (theme: Theme) => ({
	root: {
		position: 'relative',
		backgroundColor: '#1A1A1A',
		height: '100%',

		'*::-webkit-scrollbar': {
			width: '4px',
		},

		'*::-webkit-scrollbar-thumb': {
			borderRadius: '2px',
			backgroundColor: 'rgba(250, 250, 250, 0.7)',
		}
	},
	content: {
		position: 'relative',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		px: { xs: '16px', sm: '64px' },
		py: { xs: '30px', sm: '32px' },
	},
	body: {
		p: { xs: '16px 0 0 0', md: '35px 35px 0 35px' },
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		overflow: 'hidden',
		mx: 'auto',
		maxWidth: { sm: '560px', md: '940px' },
		width: '100%',
	},
	hostMemberships: {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
		backgroundColor: Colors.black_a20,
		p: '16px',
		borderRadius: '8px',
	},
	hostMembershipsText: {
		fontFamily: 'Montserrat',
		fontSize: '16px',
		fontWeight: 500,
		color: Colors.white,
		flex: 1,
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		lineHeight: '21px',
	},
	hostMembershipsLink: {
		fontFamily: 'Montserrat',
		fontSize: '15px',
		fontWeight: 700,
		color: Colors.white,
		textDecoration: 'underline',
		cursor: 'pointer',
		lineHeight: '20px',
		textUnderlineOffset: '2px',
	},
	formBody: {
		display: 'flex',
		overflow: 'auto',
		flexDirection: { xs: 'column', md: 'row' },
		gap: '16px',
	},
	form: {
		borderRadius: '8px',
		backgroundColor: '#00000080',
		p: { xs: '16px', ms: '24px' },
	},
	ticketType: {
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '15px',
		color: '#FFFFFF',
		flex: 1,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	backButton: {
		color: '#FFFFFF',
		border: '1px solid #FFFFFF66',
		width: '48px',
		height: '48px',
		mb: '24px',

		'&.Mui-disabled': {
			color: 'rgba(255, 255, 255, 0.6)'
		},
	},
	verificationTitle: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '17px',
		fontWeight: 500,
		lineHeight: '20px',
		color: '#FFFFFF',
	},
	verificationDescription: {
		fontFamily: 'Montserrat',
		fontSize: '17px',
		fontWeight: 400,
		lineHeight: '21px',
		color: '#FFFFFF',
	},
});
